import type { SearchCategory } from '@festina-life/ui/search'
import { useMemo } from 'react'

import { ConfigurationOperationSearchResult } from './ConfigurationOperationSearchResult'
import {
  type ConfigurationItemSearchMatch,
  type ConfigurationItemSearchResult,
  type ConfigurationSearchItem,
  SearchCategories,
  type SearchCategoryKey,
} from './types'
import { useCategoryTranslations } from './useCategoryTranslations'
import { useSearchOperations } from './useSearchOperations'

export const useSearchCategories = (): SearchCategory<
  ConfigurationSearchItem,
  ConfigurationItemSearchMatch,
  SearchCategoryKey
>[] => {
  const { name, className, all, properties, fplus } = useSearchOperations()
  const categoryTranslations = useCategoryTranslations()

  return useMemo(
    () => [
      {
        key: SearchCategories.itemId,
        label: categoryTranslations.itemId,
        search: name,
        render: (result: ConfigurationItemSearchResult) => (
          <ConfigurationOperationSearchResult item={result} />
        ),
      },
      {
        key: SearchCategories.class,
        label: categoryTranslations.class,
        search: className,
        render: (result) => (
          <ConfigurationOperationSearchResult item={result} />
        ),
      },
      {
        key: SearchCategories.properties,
        label: categoryTranslations.properties,
        search: properties,
        render: (result) => (
          <ConfigurationOperationSearchResult item={result} />
        ),
      },
      {
        key: SearchCategories.fplus,
        label: categoryTranslations.fplus,
        search: fplus,
        render: (result) => (
          <ConfigurationOperationSearchResult item={result} />
        ),
      },
      {
        key: SearchCategories.all,
        label: categoryTranslations.all,
        search: all,
        render: (result) => (
          <ConfigurationOperationSearchResult item={result} />
        ),
      },
    ],
    [categoryTranslations, name, className, properties, fplus, all],
  )
}
